"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function toLong(ipaddress) {
    return ipaddress.split('.').reduce(function (ipInt, octet) {
        return (ipInt << 8) + parseInt(octet, 10);
    }, 0) >>> 0;
}
exports.toLong = toLong;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVG9Mb25nLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiVG9Mb25nLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsZ0JBQXdCLFNBQWlCO0lBQ3ZDLE1BQU0sQ0FBQyxTQUFTLENBQUMsS0FBSyxDQUFDLEdBQUcsQ0FBQyxDQUFDLE1BQU0sQ0FBQyxVQUFVLEtBQUssRUFBRSxLQUFLO1FBQ3ZELE1BQU0sQ0FBQyxDQUFDLEtBQUssSUFBSSxDQUFDLENBQUMsR0FBRyxRQUFRLENBQUMsS0FBSyxFQUFFLEVBQUUsQ0FBQyxDQUFBO0lBQzNDLENBQUMsRUFBRyxDQUFDLENBQUMsS0FBSyxDQUFDLENBQUE7QUFDZCxDQUFDO0FBSkQsd0JBSUMifQ==


//////////////////
// WEBPACK FOOTER
// ./src/ToLong.ts
// module id = 0
// module chunks = 0